import { Button } from "react-bootstrap";
import useLogout from "../hooks/useLogout";

const Unauthorized = () => {
  const logout = useLogout();

  const handleLogout = () => {
    logout();
  };
  return (
    // <div className="notfoundMainWrapper">
    //   <div className="notfound">
    //     <div className="notfoundBg">
    //       <div></div>
    //       <div></div>
    //       <div></div>
    //     </div>
    //     <h1>Unauthorized</h1>
    //     <h2>You do not have access to the requested page.</h2>
    //     <Button variant="primary" onClick={handleLogout}>
    //       Go Back{" "}
    //     </Button>
    //   </div>
    // </div>
    <section className="auth-page overflow-hidden">
      <div className="conatiner h-100">
        <div className="row h-100 justify-content-center align-items-center">
          <div className="col-12 col-md-6 col-lg-4 text-center">
            <h2 className="mb-2">Unauthorized</h2>
            <p className="mb-4">
              You do not have access to the requested page.
            </p>

            <Button variant="primary" onClick={handleLogout}>
              Go Back{" "}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Unauthorized;
